export const defaultGlobalObjectKey = 'grafanaAgent';
//# sourceMappingURL=const.js.map